<ng-template #content let-modal>

    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="newClienteLabel">Crear nuevo cliente</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="clienteForm">
        <div class="modal-body">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="InputNombre">Nombre</label>
                        <input type="text" class="form-control" id="new_InputNombre" name="new_InputNombre"
                            [formControl]="clienteForm.get('nombre')" placeholder="Ingresar nombre" autocomplete="off">
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="InputApellido">Apellido</label>
                        <input type="text" class="form-control" id="new_InputApellido" name="new_InputApellido"
                            [formControl]="clienteForm.get('apellido')" placeholder="Ingresar apellido"
                            autocomplete="off">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="InputEmail">Email</label>
                        <input type="email" class="form-control" id="new_InputEmail" name="new_InputEmail"
                            [formControl]="clienteForm.get('email')" placeholder="xxxxxxx@xxxxx.xx" autocomplete="off">
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="InputTelefono">Teléfono</label>
                        <input type="text" class="form-control" id="new_InputTelefono" name="new_InputTelefono"
                            [formControl]="clienteForm.get('telefono')" placeholder="+569xxxxxxxx" autocomplete="off">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="InputDireccion">Dirección</label>
                        <input type="text" class="form-control" id="new_InputDireccion" name="new_InputDireccion"
                            [formControl]="clienteForm.get('direccion')" placeholder="Calle y número (si aplica)"
                            autocomplete="off">
                    </div>
                </div>
                <div class="col-6">
                    <app-typeahead idForm="InputComuna" label="Comuna"
                    [data]="comunas" optField="comuna_nombre"
                    [autocomplete]="false"
                    placeholder="Selecciona comuna"
                    [control]="clienteForm.get('comuna_nombre')"
                    (onSelectItem)="onSelectItemComuna($event)"></app-typeahead>
                <input type="hidden" id="InputIdCliente"
                    name="InputIdCliente"
                    [formControl]="clienteForm.get('comuna_id')"
                    autocomplete="off">
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="InputDetalle">Detalle</label>
                        <textarea class="form-control" rows="3" cols="40" id="new_InputDetalle"
                            [formControl]="clienteForm.get('detalle')" name="new_InputDetalle"
                            placeholder="N° depto / casa / oficina / otro dato (si aplica)"
                            autocomplete="off"></textarea>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class='col-12 border-bottom pb-1'>
                    <button type="button" id="refeshMap" class="btn btn-block bg-gradient-success btn-block"><i
                            class="fas fa-sync"></i> Recargar Mapa</button>
                    <div class="mapouter">
                        <div class="gmap_canvas"><iframe width="100%" height="200" id="gmap_canvas" src=""
                                frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><br>
                            <style>
                                .mapouter {
                                    position: relative;
                                    text-align: right;
                                    height: 200px;
                                    width: 100%;
                                }
                            </style>
                            <style>
                                .gmap_canvas {
                                    overflow: hidden;
                                    background: none !important;
                                    height: 200px;
                                    width: 100%;
                                }
                            </style>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="modal-footer">
            <button type="button" name="add" class="btn btn-outline-success" (click)="modal.close(clienteForm.value)"
                [disabled]="!clienteForm.valid">
                <i class="fas fa-user-plus"></i> Crear
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('close')"><i
                    class="fas fa-times"></i> Cancelar</button>
        </div>
    </form>
</ng-template>

<a class="btn btn-outline-primary btn-block btn-lg" (click)="open(content)">
    <i class="fas fa-user-plus"></i> {{buttonOnlyIcon ? '' : 'Crear nuevo cliente'}}
</a>